import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface GenerateDocumentParams {
	id: string;
	organization_id: string;
	company_id: string;
	locale: string;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useGenerateDocumentErgonomicWorkAnalysis = () => {
	return useMutation({
		mutationFn: async (params: GenerateDocumentParams) => Service.generateDocument(params),
		onSuccess: () => {
			message.success(I18n.get('Document generated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error generating document'));
		}
	});
};
